import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { IoInformationCircleOutline } from "react-icons/io5";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";

function ChartInfoTooltip({ title, tooltipText, children }) {
  return (
    <VuiBox sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <VuiBox display="flex" alignItems="center" mb={0.5}>
        <VuiTypography variant="h6" color="white" fontWeight="medium">
          {title}
        </VuiTypography>
        <Tooltip
          title={
            <VuiTypography
              variant="button"
              color="white"
              fontWeight="regular"
              sx={{
                fontSize: "11px",
                lineHeight: 1.4,
                fontFamily: "Sora, sans-serif"
              }}
            >
              {tooltipText}
            </VuiTypography>
          }
          placement="top"
          arrow
        >
          <div style={{ display: "inline-block", cursor: "pointer" }}>
            <VuiBox
              component={IoInformationCircleOutline}
              size="14px"
              color="white"
              ml={0.5}
              sx={{ opacity: 0.7 }}
            />
          </div>
        </Tooltip>
      </VuiBox>
      <VuiBox sx={{ flexGrow: 1, position: "relative", minHeight: 0, display: "flex", flexDirection: "column", height: "100%" }}>
        {children}
      </VuiBox>
    </VuiBox>
  );
}

export default ChartInfoTooltip;